import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const sid = localStorage.getItem("sb_school_id");
  if (sid) config.headers["X-School-Id"] = sid;
  const ay = localStorage.getItem("sb_ayear");
  if (ay) config.headers["X-Academic-Year"] = ay;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem("sb_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;

// Cache pendek (10 dtk) untuk GET referensi yang sering dipanggil berulang saat halaman dimuat
const _cache = new Map();
const _CACHEABLE = ["/schools/current", "/auth/plans", "/academic-years", "/schools", "/public/admin-contact"];
const _origGet = api.get.bind(api);
api.get = (url, config) => {
  if (_CACHEABLE.includes(url)) {
    const hit = _cache.get(url);
    if (hit && Date.now() - hit.t < 10000) return Promise.resolve(hit.r);
    return _origGet(url, config).then((r) => { _cache.set(url, { t: Date.now(), r }); return r; });
  }
  return _origGet(url, config);
};
const _clearCache = () => _cache.clear();
for (const m of ["post", "put", "delete", "patch"]) {
  const orig = api[m].bind(api);
  api[m] = (...args) => { _clearCache(); return orig(...args); };
}

export const BULAN = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export const formatRupiah = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);

export const formatTanggal = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return `${d.getDate()} ${BULAN[d.getMonth()].slice(0, 3)} ${d.getFullYear()}`;
};

export const apiError = (e) => {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return "Terjadi kesalahan. Coba lagi.";
};

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  kepala_sekolah: "Kepala Sekolah",
  bendahara: "Bendahara",
  orang_tua: "Orang Tua",
};
